/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/notification.ts.
 */
import {AppNotificationComponent} from '../components/notification/app.notification.component';
import {AppNotificationService} from '../services/app.notification.service';

/**
 * Zweck: Beschreibt class RenderedNotification und ihren Daten- oder Funktionsvertrag.
 */
export class RenderedNotification {
  url: string;
  icon: string;
  label: string;
  text: string;
}

/**
 * Zweck: Beschreibt class Notification und ihren Daten- oder Funktionsvertrag.
 */
export class Notification {
  id: number;
  uid: string;
  section: string;
  action: string;
  valid_to: string;
  payload: any;
  rendered: RenderedNotification;
  dat_insert: string;
  dat_insert_nice: string;
  dat_seen: string;
  dismissable: boolean;
  seen: boolean;
  is_popup: boolean;

/**
 * Beschreibt Methode getUrl und ihren Rückgabevertrag.
 */
  getUrl(svc: AppNotificationService) {
    let url = '';

    if (this.rendered) {
      url = this.rendered.url;
    }

    return url;
  }

/**
 * Beschreibt Methode getIcon und ihren Rückgabevertrag.
 */
  getIcon(notcomp: AppNotificationComponent) {
    let icon = 'info';

    if (this.rendered) {
      icon = this.rendered.icon;
    }

    return icon;
  }

/**
 * Beschreibt Methode getLabel und ihren Rückgabevertrag.
 */
  getLabel(notcomp: AppNotificationComponent) {
    let label = '';

    if (this.rendered) {
      label = this.rendered.label;

    }

    return label;
  }

/**
 * Beschreibt Methode getText und ihren Rückgabevertrag.
 */
  getText(notcomp: AppNotificationComponent) {
    let text = '';

    if (this.rendered) {
      text = this.rendered.text;
    }

    return text;
  }
}
